// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"TeamPage_toolbar__FL4d-","buttons":"TeamPage_buttons__H2Ueh","save":"TeamPage_save__32kNr","delete":"TeamPage_delete__3Nv9j","back":"TeamPage_back__sDdho"};